import {UtilSelector} from '../Core/Utils/UtilSelector.js';
import {ProjectSettings} from '../ProjectSettings.js';

class PictureTextLinkCols {
    #desktopBreakpoint;
    constructor() {
        this.#desktopBreakpoint = UtilSelector.getRootVar('desktop-breakpoint', ProjectSettings.rootVarPrefix);
    }

    init() {
        this.#realizeTextHeights();
        //realuze text height also on window resize
        window.addEventListener('resize', () => {
            this.#realizeTextHeights();
        });
    }

    #realizeTextHeights() {
        const productTextLinkCols = document.querySelectorAll('.vowe-element-picturetextlinkcols');
        productTextLinkCols.forEach(element => {
            let textsElements = element.querySelectorAll('.texts');
            textsElements.forEach(textsElement => {
                this.#realizeTextHeight(textsElement);
            });
        });
    }

    #realizeTextHeight(textsElement) {
        if (!textsElement) {
            return;
        }
        if (UtilSelector.mediaMinWidth(this.#desktopBreakpoint)) {
            if ('height' in textsElement.dataset) {
                textsElement.style.height = textsElement.dataset.height;
            }
        }
        else {
            if ('heightMobile' in textsElement.dataset) {
                textsElement.style.height = textsElement.dataset.heightMobile;
            }
        }       
    }
}

export {PictureTextLinkCols};